import BaseModel from 'AdminApp/common/script/models/BaseModel';
import Api from 'AdminApp/common/script/services/Api';

export default class DashboardModel extends BaseModel {


  async getTotalProjects() {
    let result = await Api.call(
      'dashboard/new-projects'
    );
    return result.data || [];
  }

    async getTopSchools() {
      let result = await Api.call(
        'dashboard/top-schools'
      );
      return result.data || [];
    }

}




// WEBPACK FOOTER //
// ./src/modules/dashboard/model/DashboardModel.js